<div id="wrapper">
    <app-loading-screen [status]=true></app-loading-screen>
      <div class="allcont">
        <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
        <div>
            <app-tab-nav (updateType)="this.type=$event"
            (updatePostpaid)="this.postpago=$event" 
            (updatePrepaid)="this.prepago=$event" 
            (updateFixed)="this.telefoniaFijo=$event" 
            (updateTotalAccountList)="this.totalAccountList=$event"  
            (updateCurrentList)="this.currentList=$event" 
            (updateSelectBan)="this.selectBan=$event"
            (updateInitializeData)="this.initializeData()"></app-tab-nav> 
        </div>
        <app-add-product *ngIf="this.totalAccountList==0"></app-add-product>
        <div *ngIf="this.totalAccountList > 0">
            <div class="basicrow m-top" *ngIf="(this.type=='postpaid' || this.type=='fixed')" >
                <div class="container">
                    <div class="basicr-line-i">
                        <div class="fulltitle f-btitle autodef">
                        <span class="icon-dash-04"></span> Historial de Compras
                        </div>
                        <div class="pull-right">
                            <label class="label-r sidenmbr vcenter w-auto">
                                <span class="tabcell">
                                    N&uacute;mero de Cuenta 
                                </span>
                            </label>
                            <div class="autorow subsc  mob-wid pull-right">
                                <div *ngIf="this.totalAccountList > 0">
                                    <select [(ngModel)]="this.selectBan" (change)="this.refreshDataTo($event)" class="sel-f" style="background-image:url(/assets/images/selectabarrw.png)" >
                                        <option *ngFor="let list of this.currentList" [ngValue]="list.account">{{list.account}}</option>
                                    </select>
                                </div>	
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="basicrow mbott" id="last-div" *ngIf="(this.type=='postpaid' || this.type=='fixed')">
                <div class="container">
                    <div class="basicrow">
                        <div *ngIf="this.paquetes.length==0" class="cellscont f-reg f-black noExiste">
                            No existen ordenes. 
                        </div>
                        <div class="cellscont f-reg f-black" *ngFor="let packages of this.paquetes">
                            <div class="basicrow m-top-i">
                                <div class="suscriptbar">
                                    Suscriptor: <span class="roboto-b">{{packages.SUBSCRIBER}}</span>
                                </div> 
                                <div class="boxtbl pc">
                                    <div class="tab-tbar">
                                        <div class="frwds frths rline trds vcenter">
                                            <div class="tabcell">
                                                Producto
                                            </div>
                                        </div>
                                        <div class="frwds frths rline trds vcenter">
                                            <div class="tabcell">
                                                Descripci&oacute;n
                                            </div>
                                        </div>
                                        <div class="frwds frths trds vcenter">
                                            <div class="tabcell">
                                                Costo
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caja2" *ngFor="let paquete of  packages.paquete" >
                                        <div class="basicrow">
                                            <div class="tab-cbar topgbrd">
                                                <div class="frwds trds rline vcenter">
                                                    <div class="tabcell">
                                                        {{paquete.NOMBRE}}
                                                    </div>
                                                </div>
                                                <div class="frwds trds rline vcenter">
                                                    <div class="tabcell">
                                                        {{paquete.DESCRIPCION}}
                                                    </div>
                                                </div>
                                                <div class="frwds trds vcenter">
                                                    <div class="tabcell">
                                                        <span class="roboto-b">
                                                            ${{paquete.COSTO}}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="basicrow visible-movil">
                                    <div class="basicrow" id="last-div">
                                      <div id="myCarousel5" class="carousel slide" data-interval="false" data-ride="carousel">
                                        
                                        <div class="carousel-inner">
                                          <carousel [interval]="false">
                                            <slide>
                                              <div class="item active">
                                                <div class="boxtbl">
                                                  <div class="tab-tbar">
                                                    <div class="frwds rline vcenter">
                                                      <div class="tabcell">
                                                        Producto
                                                      </div>
                                                    </div>
                                                    <div class="frwds vcenter">
                                                      <div class="tabcell">
                                                        Descripci&oacute;n
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div class="basicrow">
                                                    <div class="tab-cbar" *ngFor="let paquete of  packages.paquete">
                                                      <div class="frwds rline vcenter">
                                                        <div class="tabcell">
                                                          {{paquete.NOMBRE}}
                                                        </div>
                                                      </div>
                                                      <div class="frwds vcenter">
                                                        <div class="tabcell">
                                                            {{paquete.DESCRIPCION}}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </slide>
                                            <slide>
                                              <div class="item">
                                                <div class="boxtbl">
                                                  <div class="tab-tbar">
                                                    <div class="frwds rline vcenter completo">
                                                      <div class="tabcell">
                                                        Costo
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div class="basicrow">
                                                    <div class="tab-cbar" *ngFor="let paquete of  packages.paquete">
                                                      <div class="frwds rline vcenter completo">
                                                        <div class="tabcell">
                                                            ${{paquete.COSTO}}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </slide>
                                          </carousel>
                                        </div>
                                      </div>
                                      
                                    </div>
                                  </div>         
                                <div class="recauto" *ngIf="packages.paquete[0].RENEWAL==true">
                                    <div class="basicrow roboto-b f-black">
                                        Recurrencia Autom&aacute;tica
                                    </div>
                                    <div class="basicrow m-top-u">
                                        <div style="width: 150px; margin: 0 auto;">
                                            <label class="switch dig-def m-left-i">
                                                    <input type="checkbox" *ngIf="packages.paquete[0].RENEWALACTIVE==true && packages.paquete[0].RENEWALENABLE==true" name="checkbox1_{{packages.INDEX}}" id="checkbox1_{{packages.INDEX}}" checked (click)="this.recurrenceChange(packages.INDEX,packages.SUBSCRIBER,packages.paquete[0].OfferID,packages.paquete[0].BaseOfferID)">
                                                    <input type="checkbox" *ngIf="packages.paquete[0].RENEWALACTIVE==false  && packages.paquete[0].RENEWALENABLE==true" name="checkbox1_{{packages.INDEX}}" id="checkbox1_{{packages.INDEX}}" (click)="this.recurrenceChange(packages.INDEX,packages.SUBSCRIBER,packages.paquete[0].OfferID,packages.paquete[0].BaseOfferID)">
                                                    <input type="checkbox" disabled *ngIf="packages.paquete[0].RENEWALACTIVE==true && packages.paquete[0].RENEWALENABLE==false" name="checkbox1_{{packages.INDEX}}" id="checkbox1_{{packages.INDEX}}" checked (click)="this.recurrenceChange(packages.INDEX,packages.SUBSCRIBER,packages.paquete[0].OfferID,packages.paquete[0].BaseOfferID)">
                                                    <input type="checkbox" disabled *ngIf="packages.paquete[0].RENEWALACTIVE==false && packages.paquete[0].RENEWALENABLE==false" name="checkbox1_{{packages.INDEX}}" id="checkbox1_{{packages.INDEX}}" (click)="this.recurrenceChange(packages.INDEX,packages.SUBSCRIBER,packages.paquete[0].OfferID,packages.paquete[0].BaseOfferID)">
                                                    <span class="slider" ></span>
                                            </label>
                                        </div> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
      <app-footer></app-footer>
    </div>
